import React from "react";
import { MenuLinks } from "../MenuLinks";
import { Container } from "./style";

export const MenuDesktop = () => {
  return (
    <Container>
      <MenuLinks />
    </Container>
  );
};
